/**
 * アプリケーション全体の状態管理
 * Zustand を使用したグローバルストア
 */

import { create } from 'zustand';
import type { Employee, Assignment } from '@shift-demo/shared';

interface AppStore {
  // 従業員管理
  employees: Employee[];
  setEmployees: (employees: Employee[]) => void;
  clearEmployees: () => void;
  
  // シフト条件
  targetYear: number;
  targetMonth: number;
  setTargetDate: (year: number, month: number) => void;
  
  // シフト結果
  assignments: Assignment[];
  setAssignments: (assignments: Assignment[]) => void;
  clearAssignments: () => void;
  
  // UI状態
  isGeneratingEmployees: boolean;
  setIsGeneratingEmployees: (isGenerating: boolean) => void;
  
  isGeneratingSchedule: boolean;
  setIsGeneratingSchedule: (isGenerating: boolean) => void;
  
  error: string | null;
  setError: (error: string | null) => void;
  clearError: () => void;
  
  // 計算済みプロパティ
  hasEmployees: () => boolean;
  hasAssignments: () => boolean;
  canGenerateSchedule: () => boolean;
}

export const useAppStore = create<AppStore>((set, get) => ({
  // 従業員管理
  employees: [],
  setEmployees: (employees) => set({ employees }),
  clearEmployees: () => set({ employees: [] }),
  
  // シフト条件
  targetYear: new Date().getFullYear(),
  targetMonth: new Date().getMonth() + 1,
  setTargetDate: (year, month) => set({ targetYear: year, targetMonth: month }),
  
  // シフト結果
  assignments: [],
  setAssignments: (assignments) => set({ assignments }),
  clearAssignments: () => set({ assignments: [] }),
  
  // UI状態
  isGeneratingEmployees: false,
  setIsGeneratingEmployees: (isGenerating) => set({ isGeneratingEmployees: isGenerating }),
  
  isGeneratingSchedule: false,
  setIsGeneratingSchedule: (isGenerating) => set({ isGeneratingSchedule: isGenerating }),
  
  error: null,
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
  
  // 計算済みプロパティ
  hasEmployees: () => get().employees.length > 0,
  hasAssignments: () => get().assignments.length > 0,
  canGenerateSchedule: () => {
    const state = get();
    return state.hasEmployees() && !state.isGeneratingSchedule;
  }
}));